const HOTJAR_ID = process.env.REACT_APP_HOTJAR_ID || ''

const getHotjarElement = () => {
  const hotjarScript = `
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:${HOTJAR_ID},hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`
  const hotjarElement = document.createElement('script')
  hotjarElement.innerHTML = hotjarScript
  return hotjarElement
}

const initializeHotjar = () => {
  const hotJar = getHotjarElement()
  document.head.insertBefore(
    hotJar,
    document.head.childNodes[1] || document.head.childNodes[0]
  )
}

export { initializeHotjar }
